import {Component, Injector, OnInit} from '@angular/core';
import {JwtHelperService} from "@auth0/angular-jwt";
import {BillingService} from "./services/billing.service";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {ParameterService} from "../../_services/parameter.service";
import {InformationDialog} from "../../_shared/dialog/information.dialog";

@Component({
  selector: 'billing',
  templateUrl: './billing.component.html',
})
export class BillingComponent extends BaseComponentDirective implements OnInit {
  user: any;
  stripe_key = '';
  stripe_table_id = '';
  clientID: any;
  showStripeDashBoard = false;
  profile: any;
  private isAuth = false;
  params: any = {};
  hasRoleAdmin = false;

  constructor(
    injector: Injector,
    private jwtHelper: JwtHelperService,
    private billingService: BillingService,
    private parameterService: ParameterService
  ) {
    super(injector);
  }

  override async ngOnInit(): Promise<void> {

    this.profileMsg.currentMessage.subscribe(r => {
      if(r) {
        this.profile = r;
        console.log(this.profile);
        if(this.checkAdmin(this.profile)) {
          this.hasRoleAdmin = true;
        }
        this.logic();
      } else {
        this.authService.profile().then(rx => {
          this.profile = rx;
          this.profileMsg.changeMessage(rx);
          this.logic();
        })
      }

    });


  }

  checkAdmin(i: any) {
    for(let x = 0; x < i.roles.length; x++) {
      if(i.roles[x] === 'ROLE_ADMIN') {
        return true;
      }
    }

    return false;

  }

  async logic() {
    this.isAuth = !this.jwtHelper.isTokenExpired();

    if (this.isAuth) {
      this.params = await this.parameterService.getStripeTableData();
      this.stripe_key = this.params.publishableKey;
      this.stripe_table_id = this.params.pricingTableId;

      this.billingService.requestSession().then(res => {
        this.clientID = res.value;
        this.showStripeDashBoard = true;

      }, _ => {
        const dialog = this.dialog.open(InformationDialog, {
          data: {
            message: 'Stripe Payment Error',
            subMessage: 'An error occurs when try to connect to Stripe payment, it will force you to logged out'
          }
        })
        dialog.componentInstance.result.subscribe(r => {
          if(r) {
            localStorage.clear();
            localStorage.removeItem("token");
            this.router.navigate(['/login']).then();
          }
        })

      })

    } else {
      this.router.navigateByUrl('/landing').then();
    }
  }

  logout(): void {
    const dialog = this.dialog.open(ConfirmationDialog, {
      data: {
        message: '',
        subMessage: 'Are you sure you want to cancel the registration process and sign out?',
        buttonCancelLabel: 'Cancel',
        buttonOkLabel: 'Yes, Sign out'
      }
    });
    dialog.componentInstance.result.subscribe(r => {
      if(r) {
        localStorage.clear();
        localStorage.removeItem("token");
        this.router.navigate(['/landing']).then();
      }
    })

  }

  toBackoffice() {
    this.router.navigate(['/office/office-dashboard']).then();
  }
}
